import Hero from "@/components/home/Hero";
import VisionMission from "@/components/home/VisionMission";
import Programs from "@/components/home/Programs";
import Impact from "@/components/home/Impact";
import Philosophy from "@/components/home/Philosophy";
import LatestNews from "@/components/home/LatestNews";
import GalleryPreview from "@/components/home/GalleryPreview";
import Partners from "@/components/home/Partners";
import Testimonials from "@/components/home/Testimonials";
import CTASection from "@/components/home/CTASection";
import SDGSection from "@/components/home/SDGSection";
import SeoHead from "@/components/common/SeoHead";
import { useSettings } from "@/context/SettingsContext";

export default function Home() {
  const { settings } = useSettings();
  const hp = settings?.homepage || {};
  const show = (key, defaultVal = true) => hp[key] !== undefined ? hp[key] : defaultVal;

  return (
    <div data-testid="page-home">
      <SeoHead
        title={{ id: "Beranda", en: "Home" }}
        description={{
          id: "Sauyunan Foundation — Lembaga filantropi, kemanusiaan, dan pembangunan berkelanjutan yang menghubungkan harapan menjadi dampak nyata.",
          en: "Sauyunan Foundation — A philanthropic, humanitarian, and sustainable development foundation turning hope into real impact.",
        }}
      />
      <Hero />
      {show("show_vision_mission") && <VisionMission />}
      {show("show_programs") && <Programs />}
      {show("show_philosophy") && <Philosophy />}
      {show("show_impact") && <Impact />}
      {show("show_sdg", true) && <SDGSection />}
      {show("show_news") && <LatestNews />}
      {show("show_gallery") && <GalleryPreview />}
      {show("show_testimonials", false) && <Testimonials />}
      {show("show_partners") && <Partners />}
      {show("show_cta") && <CTASection />}
    </div>
  );
}
